<div class="home">
  <div class="banner" id="banner">
    <div id="banner-bg-addition"></div>
  </div>
  <div id="banner-bg"></div>
  <div class="profile" id="slideanimation">
    <div class="user-profile">
      <nav class="navbar navbar-light animate__animated animate__slideInDown">
        <div class="container-fluid">
          <button class="d-flex justify-content-center align-items-center flex-column" id="menu-icon"
            (click)="onMenuOpen()">
            <img [src]="constants.MENU_ICONS_IMG" alt="menu" class="hamburger-img" />
            <img [src]="constants.MENU_ICONS_IMG" alt="menu" class="hamburger-img" />
          </button>
          <a class="Ws-logo-mobile" [routerLink]="['/']">{{constants.WINDOW_SWAP_TXT}}
            <!-- <img class="Ws-logo-mobile" [src]="constants.WINDOW_SWAP_GREEN_IMG" /> -->
          </a>
          <a class="Ws-logo" [routerLink]="['/']">{{constants.WINDOW_SWAP_TXT}}
            <!-- <img class="Ws-logo" [src]="constants.WINDOW_SWAP_GREEN_IMG" /> -->
          </a>
          <div class="menus-data">
            <a><img class="profile-avatar" src="{{ profilePicture }}" /></a>
            <div class="menu">
              <div class="user-menu" id="user-menu">
                <ul>
                  <li>
                    <button *ngIf="isAdmin" type="button" class="admin">
                      <a [routerLink]="['/admin']">{{constants.ADMIN_CAP_TXT}}</a>
                    </button>
                  </li>
                  <li><a [routerLink]="['/Window']" routerLinkActive="active-link">{{constants.MENU_ITEMS.WINDOW_VIEWS}}</a></li>
                  <li><a [routerLink]="['/submit']" routerLinkActive="active-link">{{constants.MENU_ITEMS.SUBMIT_WINDOW}}</a></li>
                  <li><a [routerLink]="['/user/mywindow']" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }" (click)="toMyWindows()">{{constants.MENU_ITEMS.MY_WINDOW}}</a></li>
                  <li><a [routerLink]="['/user']" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }" (click)="toBookmarks()">{{constants.MENU_ITEMS.MYBOOKMARK}}</a></li>
                  <li><a [routerLink]="['/user/tipjar']" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }" (click)="toTipJar()">{{constants.MENU_ITEMS.MY_TIPSJAR}}</a></li>
                  <li><a [routerLink]="['/sendGift']" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }">Gift WindowSwap</a></li>
                  <li><a [routerLink]="['/user-setting']" routerLinkActive="active-link">Settings</a></li>
                  <li *ngIf="!isPrime" (click)="Takemetoprime()" id="menu-item">
                    <button class="menu-submit-button">{{constants.MENU_ITEMS.GET_ALL_ACCESS}}</button>
                  </li>
                  <li *ngIf="isPrime"><hr class="user-menu-line" /></li>
                  <li id="logout-btn"><button class="user-logout" (click)="logout()">{{constants.MENU_ITEMS.LOGOUT}}</button></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </nav>
      <div class="container">
        <div *ngIf="!isLoading">
          <div class="row user">
            <img class="profilepic" src="{{ profilePicture }}" alt="img" />
            <div class="user-body">
              <a class="card-text">
                <div *ngIf="!memberskelload">
                  <small class="memeber" *ngIf="isPrime">{{ constants.MEMBER_TXT }}
                    <span class="member-class">{{ memberId }}</span></small>
                  <small class="member-1" *ngIf="!isPrime">
                    {{ constants.MEMBER_TXT_1
                    }}<span class="member-class">{{ memberId }}</span></small>
                </div>
                <div *ngIf="memberskelload">
                  <img class="MEMBERSKEL_IMG" src="{{ constants.MEMBERSKEL_IMG }}" alt="" />
                </div>
              </a>
              <h5 class="card-title user-name" *ngIf="!memberskelload">
                {{ constants.WELCOME_TXT }} {{ userName }}!
              </h5>
              <h5 class="card-title user-name" *ngIf="memberskelload">
                <span style="width: 200px;"> <img class="MEMBERSKEL_IMG" src="{{ constants.MEMBERSKEL_IMG }}" alt="" /></span>
              </h5>
            </div>
          </div>
        </div>
        <div *ngIf="isLoading">
          <img class="profile-skelton" src="{{ constants.SKELTON_PROFILE_IMG }}" alt="" />
        </div>
      </div>
      <div class="container">
        <div class="gallery-menu">
          <li>
            <a [ngClass]="{ active: isBookmark }" (click)="bookmark()">{{
              constants.BOOKMARKED_TXT
              }}</a>
            <a [ngClass]="{ active: isMyVideo }" (click)="myVideo()">{{
              constants.MENU_ITEMS.MY_WINDOW
              }}</a>
            <a [ngClass]="{ active: isTipJar }" (click)="YourTipJar()">{{
              constants.TIPJAR_TXT
              }}</a>
          </li>
        </div>
        <hr class="hr-danger" />
      </div>

      <div class="container">
        <router-outlet></router-outlet>
      </div>
      <!-- The section below is commented out because Publift ads need to be removed. -->
      <!-- <div class="ads-wrapper" *ngIf="!isPrime">
        <div data-fuse="23174194642" id="bookmark_vrec"></div>
      </div> -->
    </div>
  </div>
</div>
<div class="mobile-menu" id="mobile-menu">
  <div class="close-button-container">
    <button class="menu-close-button" (click)="onMenuClose()">
      <i class="material-icons alert-btn-close">{{constants.CLOSE}}</i>
    </button>
  </div>
  <li>
    <a [routerLink]="['/blog']">{{ constants.BLOG_TXT }}</a>
    <a href="https://windowswapblog.squarespace.com/contact">{{
      constants.CONTACT_TXT
      }}</a>
    <a [href]="constants.SUPPORT_LINK" target="_blank">{{
      constants.BUYUSACOFFEE_TXT
      }}</a>
    <a [routerLink]="['/submit']">{{ constants.MENU_ITEMS.SUBMIT_WINDOW}}</a>
    <a [routerLink]="['/Window']">{{constants.WINDOW_VIEWS}}</a>
    <a (click)="Takemetoprime()" *ngIf="!isPrime">{{constants.MENU_ITEMS.GET_ALL_ACCESS}}</a>
    <a [routerLink]="['/user-setting']">Settings</a>
    <a style="color:#ca7358" (click)="logout()">{{constants.LOG_OUT_TXT}}</a>
  </li>
</div>

<div class="modal-popup" id="modal-popup-confirm" *ngIf="showconfirmModal">
  <div class="confirm-popup-content">
    <div class="popup-content-confirm">
      <h1>{{constants.ARE_YOU_SUBSCRIPTION_CANCEL_TXT}}</h1>
      <h1>{{constants.ARE_YOU_SUBSCRIPTION_TXT}}</h1>
      <button [disabled]="isRemoving" type="button" class="yes-button" (click)="unsubscribePrimeSubscription()">
        <div *ngIf="isRemoving" class="spinner-border removing-spinner text-light" role="status">
          <span class="sr-only">{{constants.LOADING_TEXT}}</span>
        </div>
        <div *ngIf="!isRemoving">{{constants.YES}}</div>
      </button>
      <button type="button" class="no-button" (click)=onClickCloseConfirmPopup()>
        {{constants.NO}}
      </button>
    </div>
  </div>
</div>